import React from 'react';
import BottomNav from '../components/BottomNav';

const WealthProtect = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Wealth Protection</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Secure Your Financial Future</p>
        
        <div className="card">
          <p>
            Comprehensive wealth protection strategies designed to preserve and grow your assets. 
            Expert guidance on insurance, estate planning, and asset security.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Asset Protection</h3>
              <p>Strategic planning to safeguard your wealth</p>
            </div>
            <div className="feature-item">
              <h3>Insurance Solutions</h3>
              <p>Premium coverage for high-value assets and lifestyle</p>
            </div>
            <div className="feature-item">
              <h3>Estate Planning</h3>
              <p>Comprehensive succession and legacy planning</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default WealthProtect;
